export const getIntialValues = (data = {}) => ({
  meta_seo: {
    meta_title: data?.meta_seo?.meta_title || "",
    meta_keyword: data?.meta_seo?.meta_keyword || "",
    meta_desc: data?.meta_seo?.meta_desc || "",
    meta_slug_url: data?.meta_seo?.meta_slug_url || "",
  },
  banner: {
    image: data?.banner?.image || "",
    heading: {
      white: data?.banner?.heading?.white || "",
      orange: data?.banner?.heading?.orange || "",
    },
    subHeading: data?.banner?.subHeading || "",
    paragraphs: data?.banner?.paragraphs || [""],
    cta_title: data?.banner?.cta_title || "",
    cta_download: data?.banner?.cta_download || "",
  },
  detailSection: {
    heading: {
      black: data?.detailSection?.heading?.black || "",
      orange: data?.detailSection?.heading?.orange || "",
    },
    title: data?.detailSection?.title || "",
    desc: data?.detailSection?.desc || "",
    sub_heading: data?.detailSection?.sub_heading || "",
    content: data?.detailSection?.content || [{ type: "para", text: "" }],
    image: {
      url: data?.detailSection?.image?.url || "",
      alt: data?.detailSection?.image?.alt || "",
    },
  },
  distanceSection: {
    title: data?.distanceSection?.title || "",
    desc: data?.distanceSection?.desc || "",
    cards: data?.distanceSection?.cards || [{ city: "", distance: "" }],
    bottom_para: data?.distanceSection?.bottom_para || "",
  },
  amenities: {
    title: data?.amenities?.title || "",
    highlight: data?.amenities?.highlight || "",
    subtitle: data?.amenities?.subtitle || "",
    desc: data?.amenities?.desc || "",
    image: data?.amenities?.image || "",
  },
  useCases: {
    heading: {
      title: data?.useCases?.heading?.title || "",
      highlight: data?.useCases?.heading?.highlight || "",
      subtitle: data?.useCases?.heading?.subtitle || "",
    },
    items: data?.useCases?.items || [{ title: "", desc: "", icon: "" }],
  },
  offering: {
    title: data?.offering?.title || "",
    highlight: data?.offering?.highlight || "",
    subtitle: data?.offering?.subtitle || "",
    desc: data?.offering?.desc || "",
    image: data?.offering?.image || "",
  },
  infrastructure: {
    infrastructure: {
      title: data?.infrastructure?.infrastructure?.title || "",
      highlight: data?.infrastructure?.infrastructure?.highlight || "",
      subtitle: data?.infrastructure?.infrastructure?.subtitle || "",
      image: data?.infrastructure?.infrastructure?.image || "",
      points: data?.infrastructure?.infrastructure?.points || [{ text: "", icon: "" }],
      note: data?.infrastructure?.infrastructure?.note || "",
    },
    safety: {
      title: data?.infrastructure?.safety?.title || "",
      highlight: data?.infrastructure?.safety?.highlight || "",
      subtitle: data?.infrastructure?.safety?.subtitle || "",
      image: data?.infrastructure?.safety?.image || "",
      points: data?.infrastructure?.safety?.points || [{ text: "", icon: "" }],
    },
  },
  footer_bgimg: data?.footer_bgimg || "",
});

export const generatePayload = (values) => {
  const { _id, createdAt, updatedAt, __v, ...payload } = values;
  return payload;
};
